import ApiService from '@/core/services/api.service';

export const GET_LESSON_SCORM_URL = 'getLessonScormUrl';
export const SET_ERROR = 'setError';

const state = {
    errors: null,
    scormUrl: null
};

const getters = {
    getScormUrl(state) {
        return state.scormUrl;
    },
    getErrors(state) {
        return state.errors;
    }
};

const actions = {
    [GET_LESSON_SCORM_URL](context, lessonId) {
        return new Promise((resolve, reject) => {
            ApiService.query(`academy/lessons/scorm/${lessonId}`)
                .then((result) => {
                    if (result.data.scorm_url) {
                        context.commit(GET_LESSON_SCORM_URL, result.data.scorm_url);
                        resolve(result.data.scorm_url);
                    } else {
                        reject(new Error("Cette leçon n'est pas un SCORM"));
                    }
                })
                .catch((error) => {
                    context.commit(SET_ERROR, error);
                    reject(error);
                });
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },

    [GET_LESSON_SCORM_URL](state, scormUrl) {
        state.scormUrl = scormUrl;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
